import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import { passwordValues } from "../../../lib/initialvalues/initialvalues";
import { PasswordSchema } from "../../../Validations/passwordValidation";
import { updatePassword } from "../../../apis/otpVerify";

const ChangePassword = () => {
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const navigate = useNavigate();
  let Otp = localStorage.getItem("Otp");
  let Email = localStorage.getItem("email");
  const formik = useFormik({
    initialValues: passwordValues,
    validationSchema: PasswordSchema,
    onSubmit: async (values) => {
      try {
        setLoading(true);

        const res = await updatePassword({
          email: Email,
          password: values.newPassword,
          otp: Otp,
        });
        if (res.data.success === true) {
          setLoading(false);
          setErrorMessage(res.data.result);
          navigate("/", {
            state: { successMessage: "Password Update successful" },
          });
        } else if (res.data.success === false) {
          setErrorMessage(res.data.message);
        }
      } catch (err) {}
    },
  });
  const backClick = () => {
    navigate("/");
  };

  useEffect(() => {
    if (Email == null) {
      navigate("/");
    }
  }, []);

  return (
    <div>
      <div className="account-page">
        <div className="main-wrapper">
          <div className="account-content">
            {/* Account Logo */}
            {/* <div className="account-logo">
              <Link to="/admin-dashboard">
                <img src={Applogo} alt="Dreamguy's Technologies" />
              </Link>
            </div> */}
            <div className="account-box">
              <div className="account-wrapper">
                <i
                  className="fa-solid fa-xmark"
                  style={{ fontSize: "20px", marginLeft: "400px" }}
                  onClick={backClick}
                />
                <h3 className="account-title">Change Password</h3>

                {errorMessage && (
                  <p
                    className={
                      errorMessage === "Password successfully updated"
                        ? "text-success text-center"
                        : "text-danger text-center"
                    }
                    style={{
                      fontSize: "25px",
                    }}
                  >
                    {errorMessage}
                  </p>
                )}
                <form onSubmit={formik.handleSubmit}>
                  <div className="input-block mb-3">
                    <label className="col-form-label">New password</label>
                    <input
                      type="password"
                      className="form-control"
                      name="newPassword"
                      value={formik.values.newPassword}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      required
                    />
                    {formik.touched.newPassword &&
                      formik.errors.newPassword && (
                        <div className="text-danger">
                          {formik.errors.newPassword}
                        </div>
                      )}
                  </div>
                  <div className="input-block mb-3">
                    <label className="col-form-label">Confirm password</label>
                    <input
                      type="password"
                      className="form-control"
                      name="confirmPassword"
                      value={formik.values.confirmPassword}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      required
                    />
                    {formik.touched.confirmPassword &&
                      formik.errors.confirmPassword && (
                        <div className="text-danger">
                          {formik.errors.confirmPassword}
                        </div>
                      )}
                  </div>
                  <div className="submit-section mb-4">
                    {loading ? (
                      <div
                        className="spinner-border text-primary"
                        role="status"
                      >
                        <span className="visually-hidden">Loading...</span>
                      </div>
                    ) : (
                      <button className="btn btn-primary account-btn submit-btn">
                        Update Password
                      </button>
                    )}
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChangePassword;
